import type { AuthResponse, ChangePasswordResponse, LogoutResponse, PublicUser } from '../../../shared/api/types';
import { apiRequest } from '../../../shared/api/client';

export async function loginRequest(login: string, password: string): Promise<PublicUser> {
  const data = await apiRequest<AuthResponse>('/api/auth/login', {
    method: 'POST',
    body: { login, password },
    skipUnauthorizedRedirect: true,
  });
  return data.user;
}

export async function registerRequest(
  login: string,
  password: string,
  inviteCode: string,
): Promise<PublicUser> {
  const data = await apiRequest<AuthResponse>('/api/auth/register', {
    method: 'POST',
    body: { login, password, invite_code: inviteCode },
    skipUnauthorizedRedirect: true,
  });
  return data.user;
}

export async function logoutRequest(): Promise<void> {
  await apiRequest<LogoutResponse>('/api/auth/logout', {
    method: 'POST',
    skipUnauthorizedRedirect: true,
  });
}

export async function fetchMe(): Promise<PublicUser> {
  const data = await apiRequest<AuthResponse>('/api/auth/me', {
    skipUnauthorizedRedirect: true,
  });
  return data.user;
}

export async function changePasswordRequest(
  currentPassword: string,
  newPassword: string,
): Promise<ChangePasswordResponse> {
  return apiRequest<ChangePasswordResponse>('/api/auth/change-password', {
    method: 'POST',
    body: {
      current_password: currentPassword,
      new_password: newPassword,
    },
  });
}

/** Смена часового пояса: PATCH /api/auth/me. */
export async function updateTimezoneRequest(timezone: string): Promise<PublicUser> {
  const data = await apiRequest<AuthResponse>('/api/auth/me', {
    method: 'PATCH',
    body: { timezone },
  });
  return data.user;
}
